import Vue from "vue";
import Vuex from "vuex";
import App from "@/App.vue";
import { Api } from "@/api/";
import {
  API_START_LOADING,
  API_FINISH_LOADING,
  SET_TERMINE,
  SET_CODE,
  SET_BEHANDLUNGSARTEN,
  SET_LAENDER,
  SET_MITARBEITER,
  SET_PAGE,
  SET_KOSTENUEBERNAHMEN,
  SET_START_DATE,
  SET_SELECTED_TERMIN,
  SET_ACTUAL_TERMIN,
  SET_BEHANDLUNG,
  SET_PRAXIS,
  SET_PATIENT,
  SET_ANZAHLUNG,
  SET_REFERENCE,
  SET_VORGANGSNUMMER,
  SET_CALLCENTER,
} from "./mutations.type";
import { DateTime } from 'luxon';

import termin from "./termin";
import patient from "./patient"

import praxenHager from "../static/praxen.hager";
import praxenClinius from "../static/praxen.clinius";
import praxenCliniusCh from "../static/praxen.cliniusCh";

Vue.use(Vuex);

const isClinius = process.env.VUE_APP_CUSTOMER === 'clinius';

export default new Vuex.Store({
  state: {
    loading: 0,
    behandlerlist: [],
    praxen: isClinius ? (process.env.VUE_APP_CLINIUS_CH==="1"? praxenCliniusCh : praxenClinius) : praxenHager,
    kostenuebernahmen: [],
    behandlungsarten: [],
    laender: [],
    termine: [],
    startDate: null,
    page: null,
    anzahlung: null,
    reference: null,
    vorgangsnummer: null,
    callcenter: null,
    code: null,
  },
  mutations: {
    [API_START_LOADING](state) {
      state.loading++;
    },
    [API_FINISH_LOADING](state) {
      state.loading--;
    },
    [SET_TERMINE](state, data) {
      state.termine = data;
    },
    [SET_CODE](state, data) {
      state.code = data;
    },
    [SET_MITARBEITER](state, data) {
      state.behandlerlist = data;
    },
    [SET_BEHANDLUNGSARTEN](state, data) {
      state.behandlungsarten = data;
    },
    [SET_LAENDER](state, data) {
      state.laender = data;
    },
    [SET_PAGE](state, data) {
      state.page = data;
    },
    [SET_KOSTENUEBERNAHMEN](state, data) {
      state.kostenuebernahmen = data;
    },
    [SET_START_DATE](state, data) {
      state.startDate = data;
    },
    [SET_ANZAHLUNG](state, data) {
      state.anzahlung = data;
    },
    [SET_REFERENCE](state, data) {
      state.reference = data;
    },
    [SET_VORGANGSNUMMER](state, data) {
      state.vorgangsnummer = data;
    },
    [SET_CALLCENTER](state, data) {
      state.callcenter = data;
    },
  },
  actions: {
    async loadTermine({ commit }, [fromDate, days, terminart, praxis, behandler]) {
      fromDate = fromDate.toLocaleDateString("de", { day: "2-digit", month: "2-digit", year: "numeric" })
      //let url = process.env.NODE_ENV === 'development' ? "terminedev/" : "termine/"
      let url = "termine/"
      var response = await Api.get(url, { params: { start: fromDate, terminart: terminart, days: days, praxis: isClinius ? null : praxis, behandler: behandler } });
      commit(SET_TERMINE, response.data);
      return response.data.length;
    },
    async loadTermineByTermin({ commit }, [fromDate, days, termin, praxis, behandler, single]) {
      fromDate = fromDate.toLocaleDateString("de", { day: "2-digit", month: "2-digit", year: "numeric" })
      //let url = process.env.NODE_ENV === 'development' ? "terminedev/" : "termine/"
      let url = "termine/"
      let params = { start: fromDate, termin: termin, days: days, praxis: isClinius ? null : praxis, behandler: behandler }
      if (single) params.single = true
      var response = await Api.get(url, { params: params });
      commit(SET_TERMINE, response.data);
      return response.data.length;
    },
    async loadBehandler({ commit }) {
      var response = await Api.get("mitarbeiter/");
      commit(SET_MITARBEITER, response.data);
    },
    async loadBehandlungsarten({ commit }) {
      let urlParams = new URLSearchParams(window.location.search);
      let code = urlParams.get('code');
      var response = await Api.get("behandlungsarten/", {params: {code}});

      if (response.data.length == 0) {
        alert("Der verwendete Code abgelaufen oder ungültig.");
      } else {
        commit(SET_CODE, code)
        commit(SET_BEHANDLUNGSARTEN, response.data);
      }
    },
    async loadLaender({ commit }) {
      var response = await Api.get("laender/");
      commit(SET_LAENDER, response.data);
    },
    async loadTermin({ commit }, [token]) {
      try {
        let url = "termin/"
        var response = await Api.get(url, { params: { token: token } });
        if (!response.data.termin || !response.data.behandlung) return false;
        commit(`termin/${SET_SELECTED_TERMIN}`, response.data.termin);
        commit(`termin/${SET_PRAXIS}`, response.data.termin.praxis);
        commit(`termin/${SET_BEHANDLUNG}`, response.data.behandlung);
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    async loadActualTermin({ commit, state }, [token]) {
      try {
        let url = "termin/"
        var response = await Api.get(url, { params: { token: token } });
        if (!response.data.termin || !response.data.behandlung) return false;
        commit(`termin/${SET_ACTUAL_TERMIN}`, response.data.termin);
        commit(`termin/${SET_PRAXIS}`, response.data.termin.praxis);

        if(!response.data.praxis && state.praxen.length === 1)
          commit(`termin/${SET_PRAXIS}`, state.praxen[0])
        else if(response.data.praxis)
          commit(`termin/${SET_PRAXIS}`, response.data.termin.praxis);

        commit(`termin/${SET_BEHANDLUNG}`, response.data.behandlung);
        commit(`termin/${SET_PATIENT}`, response.data.patient);
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    terminbuchungAbbrechen(context) {
      context.dispatch("termin/clear");
      context.dispatch("patient/clear");
    },
    verschiebenAbbrechen(context) {
      context.dispatch("termin/clearSelectedTermin");
    },
    async confirmTermin({ commit }, [token]) {
      try {
        var response = await Api.get("/book/confirm/", { params: { token: token } });
        if (response.data.termin) {
          commit(`termin/${SET_SELECTED_TERMIN}`, response.data.termin);
          commit(`termin/${SET_PRAXIS}`, response.data.termin.praxis);
        }
        if (response.data.behandlung)
          commit(`termin/${SET_BEHANDLUNG}`, response.data.behandlung);

        return response.data.success;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    async cancelTermin({ commit }, [token]) {
      try {
        var response = await Api.get("/book/cancel/", { params: { token: token } });
        if (response.data.termin) {
          commit(`termin/${SET_SELECTED_TERMIN}`, response.data.termin);
          commit(`termin/${SET_PRAXIS}`, response.data.termin.praxis);
        }
        if (response.data.behandlung)
          commit(`termin/${SET_BEHANDLUNG}`, response.data.behandlung);

        return response.data.success;
      } catch (error) {
        console.error(error);
        return false;
      }
    }
  },
  modules: {
    patient,
    termin
  },
  getters: {
    callcenter: (state) => {
      return state.callcenter;
    },
    isLoading: (state) => {
      return state.loading > 0;
    },
    termineAtDay: (state) => (date, vorverlegt = false) => {
      // gib Termine für einen Tag zurück
      // Form {'11:00':[{prop1}, {prop2}], '13:00':[{prop1}]}

      // Funktion zum gruppieren nach Uhrzeit
      var groupByTime = (acc, val) => {
        let startTime = DateTime.fromISO(val.start).setLocale(App.i18n.locale).toLocaleString({hour: "2-digit", minute: "2-digit"});
        (acc[startTime] = acc[startTime] || []).push(val)
        return acc;
      }

      // Filtere Vorschläge nach Tag und Behandler und gruppiere sie danach
      let proposalsAtDay = state.termine.filter((t) => {
        let d = DateTime.fromISO(t.start)
        return d.hasSame(DateTime.fromJSDate(date), 'day')
      });
      let proposals = proposalsAtDay.filter((t) =>
        (!vorverlegt || t.stornierung.vorverlegt)
      ).reduce(groupByTime, {})

      return proposals
    },
    getBehandler: (state) => (id) => {
      let behandler = state.behandlerlist.find((b) => b.id == id)
      return behandler;
    },
    getCode: (state) => {
      return state.code
    }
  },
});
